<template>
    <date-pick
        id="date-modal"
        :style="style"
        class="date-modal"
        v-if="show"
        v-model="model"
        :format="'YYYY-MM-DD HH:mm'"
        :hasInputElement="false"
        :weekdays="weekdays"
        :months="months"
        v-bind="modalProps" />
</template>

<script>
import { mapGetters } from 'vuex';
import DatePick from 'vue-date-pick';
import moment from 'moment';

export default {
    data() {
        return {
            weekdays: ['MA', 'DI', 'WO', 'DO', 'VR', 'ZA', 'ZO'],
            months: [
                'januari',
                'februari',
                'maart',
                'april',
                'mei',
                'juni',
                'juli',
                'augustus',
                'september',
                'oktober',
                'november',
                'december',
            ],
        };
    },
    computed: {
        ...mapGetters({
            show: 'dateModal/showModal',
            position: 'dateModal/getPosition',
            modalProps: 'dateModal/getProps',
        }),
        model: {
            get() {
                const value = this.$store.getters['dateModal/getValue'];
                return value
                    ? moment.utc(value).format('YYYY-MM-DD HH:mm')
                    : value;
            },
            set(value) {
                value = moment.utc(value, 'YYYY-MM-DD HH:mm').toISOString();
                this.$store.commit('dateModal/setValue', value);
            },
        },
        style() {
            if (!this.position) {
                return null;
            }

            return {
                top: this.position.top + 'px',
                left: this.position.left + 'px',
            };
        },
    },
    components: {
        DatePick,
    },
};
</script>
